import React from 'react';
import SubComponents from '../Common/SubComponent';
import { BasicModal } from '@beisen/chaos-ui';
import FieldMapInstance from './FieldMap';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import ComponentHolder from '../Common/ComponentHolder';
import FormHelper from './FormHelper';
import classnames from 'classnames';
import { formatUrl, getButtonQueryBodyParams, keepHttpsProtocolSame } from '../util/url';
import { getAjaxListParams, getFeatureToken,deepClone } from '../util/helper';
import * as approvelHelper from '../util/approvelHelper';
import transLoader from '@beisen/i18n-translation-loader';
import { getExtensionCmpByViewPath } from '../util/extension';
import { isInvisible } from '../util/componetState';
require('./form.scss');
const dataSourceFilter = ['BC_Staff', 'BC_UserSelect', 'BC_PopArea'];

const defaultTranslation = {
    confirm: '确定',
    cancel: '取消'
};
class Form extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.errorScrollInToView = this.errorScrollInToView.bind(this);
        this.cancleConfirm = this.cancleConfirm.bind(this);
        this.submitConfirm = this.submitConfirm.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.isMultiForm = this.props.cmp_data.hasOwnProperty('formViewType') ? !!this.props.cmp_data['formViewType'] : false;
        this.rememberPosition = this.rememberPosition.bind(this);

        this.getSearchData = this.getSearchData.bind(this);
        this.synBizData = this.synBizData.bind(this);

        this.translation = Object.assign({}, defaultTranslation, transLoader({
            confirm: 'common.confirm',
            cancel: 'common.cancel'
        }), props.translation);
    }

	rememberPosition(e) {
		if(e && e.target) {
			localStorage.setItem('searchFormListScrollTop',e.target.scrollTop);
		}
	}
    componentDidMount() {
        //为了处理input在滑动过程中不失焦的问题，导致点击选择框后，input继续获取焦点
        document.querySelector('body').addEventListener('touchend', this.activeElementBlur);
    }
    componentWillUnmount() {
        document.querySelector('body').removeEventListener('touchend', this.activeElementBlur);
    }
    activeElementBlur(e) {
        let tagName = e.target.tagName;
        if (tagName.toUpperCase() != 'INPUT' && tagName.toUpperCase() != 'TEXTAREA') {
            //让获取焦点的失焦
            document.activeElement.blur();
        }

    }
    handleFocus() {
        if(this.props.formType === 'searchForm') return;
        if(!this.isObjectEmpty(this.props.form_errors)) {
            this.props.actions.removeAllError(this.props.cmp_id);
        }
    }

    // 处理高级lookup相关逻辑
    handleAdvanceLookUp(value) {
        if(this.props.pop_type !== 'searchItem') {
            this.props.onBlur && this.props.onBlur(value);
        }else {
            this.searchItemValue = value;
        }
    }

    updateRelationFields(fieldName,dataObj = {},isAllowedToSetRelationDataValue = false) {
        if(!isAllowedToSetRelationDataValue) return;
        const params = {
            app: BSGlobal.application,
            viewName: this.getViewName(),
            metaObjName: this.props.cmp_data.metaObjectName,
            fieldName: fieldName || '',
            fieldValue: dataObj.value || ''
        };

        this.props.actions.setRelationFieldsTextValue(params, this.props.cmp_id);
    }

    handleChange(value, cmp_relative_data, validators) {
        let obj = {};
        obj[cmp_relative_data.field_name] = value;
        cmp_relative_data.form_id = this.props.cmp_id;

        if(this.props.formType === 'searchForm') {
            if(!value) {
                return;
            }
            value['num'] = cmp_relative_data['num'];
            //lookup高级搜索 注意：输入框的确定提交会走blur，选择类组件确定提交会走change
            if(this.props.isLookupAdvanced) {
                this.handleAdvanceLookUp(value);
                return;
            };
            obj[cmp_relative_data.field_name] = value;
            // 将数据更新至 searchForm 临时节点 确定时才同步到biz_data
            this.props.actions.searchFieldChangeAdapter(value, cmp_relative_data ,obj);
            if(this.props.onChange) {
                this.props.onChange(value, cmp_relative_data);
            }
            return;
        }

        const tempFormData = Object.assign({}, this.props.biz_data, obj);
        this.lastChangedValue = Object.assign({}, obj);
        this.props.actions.fieldChangeAdapter(value, cmp_relative_data, tempFormData);
        this.updateRelationFields(cmp_relative_data.field_name,value,cmp_relative_data.isAllowedToSetRelationDataValue);
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }


    handleBlur(value, cmp_relative_data) {
        let obj = {};
        obj[cmp_relative_data.field_name] = value;
        cmp_relative_data.form_id = this.props.cmp_id;

        if (this.props.formType === 'searchForm') {
            value['num'] = cmp_relative_data['num'];
            obj[cmp_relative_data.field_name] = value;
            this.lastChangedValue = Object.assign({}, obj);
            //lookup高级搜索 注意：输入框的确定提交会走blur，选择类组件确定提交会走change
            if(this.props.isLookupAdvanced) {
                this.handleAdvanceLookUp(value);
                return;
            }
            const tempFormData = Object.assign({}, this.props.tempFormData, obj);
            // 将数据更新至 searchForm 临时节点 确定时才同步到biz_data
            this.props.actions.searchFieldChangeAdapter(value, cmp_relative_data, tempFormData);
            return;
        }

        /**
         * 处理点击一个字段，不做任何输入，直接点击保存时，会验证此字段的bug
         */
        if(obj[cmp_relative_data.field_name].text === '' && obj[cmp_relative_data.field_name].value === '' && !this.props.biz_data[cmp_relative_data.field_name]) {
            return null;
        }
        this.lastChangedValue = Object.assign({}, obj);
        const tempFormData = Object.assign({}, this.props.biz_data, obj);
        this.props.actions.fieldChangeAdapter(value, cmp_relative_data, tempFormData);
        this.updateRelationFields(cmp_relative_data.field_name,value,cmp_relative_data.isAllowedToSetRelationDataValue);
    }

    synBizData() {
        if(this.props.isLookupAdvanced && this.props.onBlur && this.searchItemValue) {
            this.props.onBlur(this.searchItemValue);
        } else {
            this.props.synBizData && this.props.synBizData();
        }
    }

    handleClick(e, field_name, field_dom) {
        if (this.props.onClick) {
            this.props.onClick(field_dom);
        }
    }

    getFieldsFormatContained(options = { filterInvisible: false }) {
        let partCmps = [];
        this.props.sub_cmps.forEach((partCmp, index) => {
            if(partCmp.cmp_type == 'FormPart') {
                partCmp.sub_cmps.forEach((cmp, index) => {
                    if(options.filterInvisible && isInvisible(cmp.cmp_data)) {
                        return;
                    }
                    let field = this.isMultiForm &&  cmp.cmp_data.field_name_for_multi ? cmp.cmp_data.field_name_for_multi : cmp.cmp_data.field_name;
                    partCmps.push(field);
                });
            }
        });
        return partCmps;
    }

    getmetaObjName() {
        return this.props.popOptions.cmpContext.metaObjName || this.props.cmp_data.metaObjectName;
    }

    getViewName() {
        return this.props.cmp_data.viewName;
    }


    //处理searchForm数据格式化
    formatSearchFormData() {
        const { cmp_data,biz_data } = this.props;
        let items = [];

        for(let prop in biz_data) {
            items.push({
                'name': prop,
                'text': biz_data[prop].text,
                'value': biz_data[prop].value
            });
        }
        return {
            'metaObjName': cmp_data.metaObjectName,
            'searchView': cmp_data.viewName,
            'items': items
        };

    }

    getSearchData() {
        return this.formatSearchFormData();
    }

    addLastChangeField(bizData) {
        const prop = Object.keys(this.lastChangedValue)[0];
        const propVal = this.lastChangedValue[prop].value;
        if(propVal && typeof propVal == 'string' && propVal.startsWith('dfs://')) {
            return;
        }
        const metaObjName = this.getmetaObjName();
        const exsitedField = bizData.find(item => item.name === prop);
        const lastFieldObj = {
            'name': prop,
            'text': this.lastChangedValue[prop].text,
            'value': this.lastChangedValue[prop].value,
            'metaObjName': metaObjName
        };
        exsitedField ? Object.assign(exsitedField,lastFieldObj) : bizData.push(lastFieldObj);
    }

    addPObjectDataID(bizData) {
        const { popOptions } = this.props;
        const metaObjName = this.getmetaObjName();
        let pObj = bizData.find(item => item.name === 'PObjectDataID');
        if (pObj) {
            pObj['value'] = pObj.value || popOptions.cmpContext.pObjectDataID;
        } else if (popOptions.cmpContext.pObjectDataID) {
            bizData.push({
                'name': 'PObjectDataID',
                'text': '',
                'value': popOptions.cmpContext.pObjectDataID,
                'metaObjName': metaObjName
            });
        }
    }

    removeApprovelFields(bizData) {
        //将审批插入的审批字段过滤掉
        return bizData.filter(item => {
            if(approvelHelper.approvelCmps.includes(item.name)) {
                this[item.name] = item.value;
                return false;
            }
            return true;
        });
    }

    // 批量编辑保存时 没有操作的数据都传递空值
    addBatchData(bizData) {
        const allFormPartFields = this.getFieldsFormatContained({ filterInvisible: true });
        let allData = {};
        allFormPartFields.forEach(name => {
            allData[name] = {
                'name': name,
                'text': '',
                'value': '',
                'num': ''
            };
        });
        return Object.assign({},allData,bizData);
    }

    formatBizData() {
        const { biz_data: currentBizData,isBatch } = this.props;
        let biz_data = Object.assign({},currentBizData);
        if(isBatch) {
            biz_data = this.addBatchData(currentBizData);
        }
        let bizData = [];
        const metaObjName = this.getmetaObjName();
        const allFormPartFields = this.getFieldsFormatContained();
        for (let prop in biz_data) {
            const shouldPushBizData = biz_data.hasOwnProperty(prop) && allFormPartFields.indexOf(prop) >= 0 || prop == 'PObjectDataID' || (this.isMultiForm && prop != '_id' && prop.endsWith('_id'));
            if (shouldPushBizData) {
                let metaFieldObj = {
                    'name': prop,
                    'text': biz_data[prop].text,
                    'value': biz_data[prop].value,
                    'metaObjName': metaObjName
                };
                bizData.push(metaFieldObj);
            }
        }
        this.lastChangedValue && this.addLastChangeField(bizData);
        this.addPObjectDataID(bizData);
        //将审批插入的审批字段过滤掉
        bizData = this.removeApprovelFields(bizData);
        return bizData;
    }

    getBatchData() {
        const { isBatch,dataArr, firstField } = this.props;
        if(isBatch) {
            let targetModels = [];
            dataArr.forEach(item => {
                targetModels.push({ id: item['_id'], showText: item[firstField] || '' });
            });

            return { targetModels };
        }
        return {};
    }

    formatSumbmitFormData() {
        const { popOptions , dataArr } = this.props;
        const viewName = this.getViewName();
        const checkRequired = false; //TODO: checkRequired 的规则
        const formState = popOptions.params.formState;
        const bizData = this.formatBizData();
        //处理queryBody_ 开头的参数
        const queryBodyParams = getButtonQueryBodyParams(this.props.popOptions.params, dataArr,this.props.popOptions.queryUrl);
        //表单字段数据
        const formData = {
            'metaFields': bizData,
            'viewName': viewName,
            'checkRequired': checkRequired,
            'formState': formState
        };
        return Object.assign({}, formData,queryBodyParams,this.getBatchData());
    }

    isFormPartHidden(cmp) {
        return (cmp.cmp_type == 'FormPart' && cmp.cmp_data && !cmp.cmp_data.visible);
    }

    extracValidators(tree, validators) {
        if (tree.validators && !this.isObjectEmpty(tree.validators) && !isInvisible(tree.cmp_data)) {
            const field = this.isMultiForm && tree.cmp_data.field_name_for_multi ? 'field_name_for_multi' : 'field_name';
            //如果是图片上传或者附件上传,则在同步验证规则中去掉图片格式验证规则(图片验证规则是异步验证的)
            if(tree.cmp_type === 'BC_PictureUploader' || tree.cmp_type === 'BC_FileUploader') {
                delete tree.validators.FileExtensionValidate;
                delete tree.validators.FileSizeValidate;
            }
            validators[tree.cmp_data[field]] = tree.validators;
            return true;
        }
        if (tree.sub_cmps && tree.sub_cmps.length > 0 && !this.isFormPartHidden(tree)) {
            tree.sub_cmps.forEach(item => {
                this.extracValidators(item, validators);
            });
        }
        return false;
    }

    extracDataSourceNames(tree, dataSourceNameObj) {
        if (!tree.cmp_data.dataSourceServiceName && tree.cmp_data && tree.cmp_data.datasourcename && dataSourceFilter.indexOf(tree.cmp_data.cmp_type) === -1 && tree.cmp_type != 'BC_PopArea' && tree.cmp_type != 'BC_PopTree') {
            let ds = {
                dsName: tree.cmp_data.datasourcename,
                fieldName: this.isMultiForm ? tree.cmp_data.field_name_for_multi : tree.cmp_data.field_name,//todo 修改为长名
                filter: this.getQueryString(tree.cmp_data),
                refreshParams: this.props.getRefreshParams && this.props.getRefreshParams(tree.cmp_data.refreshParams) || ''
            };

            if(tree.cmp_data && tree.cmp_data.applicationName) {
                ds.applicationName = tree.cmp_data.applicationName;
            }

            if(tree.cmp_data && tree.cmp_data.metaObjectName) {
                ds.metaObjectName = tree.cmp_data.metaObjectName;
            }
            dataSourceNameObj.push(ds);
            return true;
        }
        if (tree.sub_cmps && tree.sub_cmps.length > 0) {
            tree.sub_cmps.forEach(item => {
                this.extracDataSourceNames(item, dataSourceNameObj);
            });
        }
    }

    getQueryString(cmp_data) {
        let formUrlOption = this._getFormUrlOption();
        let crossAppParams = {};
        if(cmp_data.applicationName) {
            crossAppParams.app = cmp_data.applicationName;
        }
        if(cmp_data.metaObjectName) {
            crossAppParams.metaObjName = cmp_data.metaObjectName;
        }

        Object.assign(formUrlOption,{ app: window.BSGlobal.application });
        if(formUrlOption.formState == 'create') {
            delete formUrlOption.id;
        }
        let queryString = '';
        for(let key in formUrlOption) {
            queryString += key + '=' + formUrlOption[key] + '&';
        }
        return queryString.substr(0, queryString.length - 1);
    }

    // button事件参数
    getButtonParams() {
        // 20181030依照PC端逻辑变更 业务有增加其他自定义参数的需求 这里改为反向逻辑 去掉不必要参数之后将其他参数都拼接上去
        let tempParams = deepClone(this.props.popOptions.params);

        // 所有无需增加到 formview 请求的属性
        const removeKeys = ['id', 'ids', '_id', 'dataRows', 'dataType', 'formSaveUrl', 'formState', 'metaObjName', 'ref', 'title', 'type', 'tempType', 'viewName', 'titleIcon', 'CurrentApprovalUserIDsText'];
        // 去掉所有 object 类型的属性，因为无法通过表单直接传递
        // 去掉 queryBody 和 _datas_ 开头的属性 因为这些属性是给 form 保存时使用的
        for(let key in tempParams) {
            if (typeof tempParams[key] == 'object' || key.indexOf('queryBody_') == 0 || key.indexOf('_datas_') == 0 || removeKeys.includes(key)) {
                delete tempParams[key];
            }
        }
        return tempParams;
   }

    _getFormUrlOption() {
        const { buttonData } = this.props;
        const id = this.props.popOptions.id || this.props.popOptions.ids || '';
        const metaObjName = this.props.popOptions.cmpContext.metaObjectName || this.props.popOptions.cmpContext.metaObjName;
        const formState = this.props.popOptions.params.formState;
        const viewName = this.props.popOptions.params.viewName || this.props.popOptions.cmpContext.viewName || this.props.cmp_data.viewName;
        let getOptions = {
            metaObjName
            ,formState
            ,id
        };
        if(viewName) {
            getOptions.viewName = viewName;
        }
        getOptions = this.addParentData(getOptions);

        // 扩展弹出自定义表单 追加自定义参数
        const urlParams = buttonData && buttonData.urlParams;

	    Object.assign(getOptions, this.getButtonParams(), urlParams);
        return getOptions;
    }

    addParentData(obj) {
        const parentDataId = this.props.popOptions.cmpContext.parentDataId,
            parentMetaObjName = this.props.popOptions.cmpContext.parentMetaObjName;
        if(parentDataId && parentMetaObjName) {
            obj['parentDataId'] = parentDataId;
            obj['parentMetaObjName'] = parentMetaObjName;
        }
        return obj;
    }

    isObjectEmpty(obj) {
        return typeof (obj) === 'undefined' || Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
    }

    getValidatorConstraints() {
        let constraints = {};
        this.extracValidators(this.props, constraints);
        return constraints;
    }

    isStandardFromSave() {
        return this.props.cmp_data && this.props.cmp_data.formState === 'create' && this.props.popOptions && !this.props.popOptions.saveURL;
    }

    getTaskData() {
        let taskData = {};
        const fields = approvelHelper.getExistFields(this.props.popOptions);
        fields.forEach(field => {
            taskData[field.taskKey] = this[field.name] || '';
        });
        return taskData;
    }

    //当审批按钮中配置了提交弹出form的场景
    completeTask() {
        let fetchUrl = keepHttpsProtocolSame(this.props.popOptions.params.completeTaskUrl);
        this.props.actions.completeTask(fetchUrl,this.getTaskData(),[
            function(ajaxRespone) {
                this.props.stopLoading();
                if(ajaxRespone && ajaxRespone.data && ajaxRespone.data.code && ajaxRespone.data.code != '200') {
                    return null;
                }
                setTimeout(() => {
                    this.props.actions.btnNextFn();
                },1000);
            }.bind(this)
        ]);
    }

    saveAfter = result => {
        if(this.props.popOptions.params.isApprovalButton) {
            this.props.toggleDisableButton(true);
            this.completeTask();
            return null;
        }

        let resp = result.data, isNext = false;
        let data = [];
        data.push(resp);
        if(resp) {
            this.props.stopLoading();
            if(resp.flag || resp.code == 200 || !resp.hasOwnProperty('code')) {
                isNext = true;
            }

        }
        setTimeout(() => {
            if(isNext) {
                if(this.props.onSaveDataSuccess) {
                    this.props.onSaveDataSuccess(resp);
                    return null;
                }

                //修复新增跳转到详情页的bug，button这块儿逻辑整体都需要重构
                let nextBtnData =  resp.id && this.isStandardFromSave() ? {
                    resultData: resp,
                    selectData: [{ id: resp.id }]
                } : {
                    resultData: resp,
                    selectData: this.props.dataArr || data
                };

                this.props.actions.btnNextFn(nextBtnData);
            }
        },2000);
    }

    getSaveUrl(url,data,queryUrl) {
        const cmpContext = this.getFormContext();
        for(let prop in data) {
            if(data[prop] && data[prop].hasOwnProperty('text') && data[prop].hasOwnProperty('value')) {
                data[prop] = data[prop].value;
            }
        }

        return formatUrl(url,queryUrl,cmpContext,data);
    }

    // 验证通过后
    afterValidatePass() {
        const { popOptions ,cmp_id, biz_data, sub_cmps, isBatch, buttonData, analysisData } = this.props;
        const ajaxParams = getAjaxListParams(buttonData,'formSaveUrl');
        //const formSaveUrl = ajaxParams ? ajaxParams.apiUrl : popOptions.params.formSaveUrl;
        const ajaxMethod = ajaxParams ? ajaxParams.method.toUpperCase() : (popOptions.params.method ? popOptions.params.method.toUpperCase() : popOptions.params.method);
        const parentMetaObjName = popOptions.queryUrl.pageModule ? JSON.parse(decodeURIComponent(popOptions.queryUrl.pageModule)).metaObjName : popOptions.queryUrl.metaObjName;
        const otherParams = {
            isBatch: isBatch,
            saveURL: this.getSaveUrl(popOptions.params.formSaveUrl,popOptions.data,popOptions.queryUrl),
            form_id: cmp_id,
            method: ajaxMethod,
            formState: popOptions.params.formState,
            id: toString.call(popOptions.data.id) === '[object Object]' ? popOptions.data.id.value : popOptions.data.id || popOptions.data.ids,
            metaObjName: popOptions.params.metaObjName || popOptions.cmpContext.metaObjName,
            dataArr: this.props.dataArr,
            data: popOptions.data,
            isMultiForm: this.isMultiForm
        };

        if(ajaxParams) {
            otherParams['header'] = getFeatureToken(ajaxParams);
        }

        const parentDataId = popOptions.cmpContext.parentDataId || popOptions.cmpContext.pObjectDataID;
        //const parentMetaObjName = popOptions.cmpContext.parentMetaObjName || popOptions.cmpContext.metaObjName;

        if(parentDataId && parentMetaObjName) {
             otherParams.parentDataId = parentDataId;
             otherParams.parentMetaObjName = parentMetaObjName;
        }

        if(analysisData) {
            otherParams.analysisData = analysisData;
        }

        // 扩展弹出自定义表单 追加自定义参数
        const urlParams = buttonData && buttonData.urlParams;

        //form保存成功后是否禁用成功提示
        otherParams.disableSuccessTip = !!popOptions.params.disableSuccessTip;

        let nextActions = [this.saveAfter];
        this.props.actions.saveFormData(this.getFormData(), Object.assign({},otherParams,urlParams), nextActions);
    }

    validateForm() {
        const validateBussinessLogin = this.props.cmp_data.saveConfirmPop || this.props.cmp_data.url;
        const { biz_data: currentBizData, cmp_data, cmp_id,isBatch } = this.props;
        const formparts = this.props.sub_cmps.map((sub,index) => {
            if(sub.cmp_type === 'FormPart') {
                return sub.sub_cmps;
            }
        });
        //将所有表单内容打平到formpart_cmps数组中
        let formpart_cmps = formparts[0];
        if(formparts.length > 1) {
            formparts.forEach((item,index) => {
                if(index > 0) {
                    formpart_cmps = formpart_cmps.concat(item);
                }
            });
        }
        let biz_data = Object.assign({},currentBizData); ;
        if(isBatch) {
            biz_data = this.addBatchData(currentBizData);
        }
        //getValidatorConstraints 得到验证的约束
        const c = this.getValidatorConstraints();
        this.props.actions.validate_form(formpart_cmps, biz_data, c, cmp_id, validateBussinessLogin,
            cmp_data.viewName, this.getFormData(), () => {
            this.afterValidatePass();
        },this.isMultiForm,this.props.cmp_data.url,() => {
            this.props.stopLoading();
        });
    }

    getDataSourceNames() {
        let dataSouceNames = [];
        this.extracDataSourceNames(this.props, dataSouceNames);
        return dataSouceNames;
    }

    getFormData() {
        let searchData = {};
        const { popOptions = {}, buttonData = {} } = this.props;
        const { postSearchData } = popOptions.params || {};
        if (postSearchData && postSearchData.trim() === 'true') {
            searchData = { search_data: buttonData.searchCriteria };
        }
         // 业务需求：在所有表单保存时追加搜索条件参数
        return Object.assign({}, searchData, this.getExtendSaveData(),this.formatSumbmitFormData());
    }

    getExtendSaveData() {
        let extendData = sessionStorage.getItem('standardForm_extend_data');
        if (extendData) {
            return { extendSaveData: JSON.parse(extendData) };
        }else {
            // 参数只支持 ,extendSaveData_WorkId:{data.WorkId}  这种形式  从data中取值
            const { popOptions } = this.props;
            const { data } = popOptions;
            let extendSaveData = {};
            if(popOptions && popOptions.params) {
                for(let key in popOptions.params) {
                    if(key.match(/extendSaveData_/)) {
                        let value = popOptions.params[key];
                        let node = value.replace('{', '').replace('}', '').split('.');
                        let tmpVal;
                        if (node.length > 1) {
                            if(node[0].match(/^data/)) {
                                tmpVal = data[node[1]];
                            }else{
                                tmpVal = value;
                            }
                        }else {
                            tmpVal = value;
                        }
                        extendSaveData[key.slice('extendSaveData_'.length)] = tmpVal;
                    }
                }
            }
            return Object.keys(extendSaveData).length > 0 ? { extendSaveData: extendSaveData } : {};
        }
    }

    saveForm() {
        this.validateForm();
    }

    getFormContext() {
        const { cmp_data = {},popOptions,biz_data: bizData } = this.props;
        const formContext = {
            metaObjName: cmp_data.metaObjectName,
            viewName: cmp_data.viewName
        };
        let popContext = {};
        if (popOptions) {
            const { queryUrl,cmpContext = {},data = {} } = popOptions;
            popContext = {
                queryUrl,
                cmpContext,
                bizData,
                id: data.id,
                parentDataId: cmpContext.parentDataId || cmpContext.pObjectDataID,
                parentMetaObjName: cmpContext.parentMetaObjName || cmpContext.metaObjName
            };
        }
        return Object.assign(formContext,popContext);
    }

    cancleConfirm() {
        const isCancel = true;
        this.props.stopLoading && this.props.stopLoading();
        this.props.toggleDisableButton(false);
        this.props.actions.hideFormConfirm(isCancel);
    }

    submitConfirm() {
        this.afterValidatePass();
        this.props.actions.hideFormConfirm();
    }

    errorScrollInToView() {
        if(this.props.formType === 'searchForm') return;
        return !this.isObjectEmpty(this.props.form_errors) && this.props.form_errors;
    }

    renderConfirm() {
        const { translation } = this;
        const strictControl = this.props.confirmData ? !this.props.confirmData.StrictControl : 0;
        // 扩展弹窗内容组件
        const extensionPath = this.props.popOptions.params && this.props.popOptions.params['ConfirmViewPath'];
        const ExtensionCmp = extensionPath && getExtensionCmpByViewPath(extensionPath);
        if(ExtensionCmp) {
            return (<BasicModal
                        cls='form_confirm'
                        visible={true}
                        animation="zoom"
                        maskAnimation="fade"
                        maskClosable={false}
                        emptyBox
                    >
                        <ExtensionCmp {...this.props.confirmData} cancel={this.cancleConfirm} confirm={this.submitConfirm} />
                    </BasicModal>);
        }
        const cancleBtnObj = {
            text: translation.cancel
            ,onTouchTap: this.cancleConfirm
        };

        const submitBtnObj = strictControl ? { text: translation.confirm,
                                             onTouchTap: this.submitConfirm
                                           } : {};
        const { title, message } = this.props.confirmData || {};
        return (
            <BasicModal
                cls='form_confirm'
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                title={title}
                children={message}
                footer={[cancleBtnObj, submitBtnObj]}
            />
        );
    }

    render() {
        const { confirmData, containerContext } = this.props;
        const isConfirm = confirmData && confirmData.hasOwnProperty('IsBeyondEstablishment') ? confirmData.IsBeyondEstablishment : 0;

        const form_state = this.props.cmp_data ? this.props.cmp_data.cmp_state : '';
        const form_id = this.props.cmp_id;
        const compactForm = this.props.cmp_data.compact ? 'compact_form_part' : '';
        const _formElements = [];
        // 渲染表单帮助区域
        if (this.props.cmp_data.messagePrompt) {
            _formElements.push(
                <li>
                    <FormHelper {...this.props.cmp_data.messagePrompt} />
                </li>
            );
        }

        if (this.props.cmp_data.expandRegion) {
            _formElements.push(
                <li>
                    <ComponentHolder
                        compact={true}
                        componentName={this.props.cmp_data.expandRegion.view_path}
                        {...this.props}
                        metaObjName={this.getmetaObjName()}
                        viewName={this.getViewName()}
                    />
                </li>
            );
        }

        _formElements.push(
            <li>
                <div className={classnames('form_part_com', compactForm)}>
                    <SubComponents
                        {...this.props}
                        form_context={this.getFormContext()}
                        componentMap={FieldMapInstance}
                        form_state={form_state}
                        form_id={form_id}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        errorScrollInToView={this.errorScrollInToView}
                        onClick={this.handleClick}
                        onTouchStart={this.touchStart}
                        onToScroll={this.props.onToScroll}
                        synBizData={this.synBizData}
                        compact={this.props.cmp_data.compact}
                        isMultiForm={this.isMultiForm}
                        containerContext={containerContext}
                        getRefreshParams={this.props.getRefreshParams}
                    />
                </div>
            </li>
        );

        if(isConfirm) {
            _formElements.push(<li>{this.renderConfirm()}</li>);
        }

        return (
            <div ref='' className={classnames('list-block inputs-list')}>
                <ul className={'list-block-ul'} onScroll={this.rememberPosition}>
                    {_formElements}
                </ul>
            </div>
        );
    }
}
Form.defaultProps = {
    cmp_data: null,
    sub_cmps: [],
    biz_data: {},
    form_errors: {},
    actions: {},
    editable: false,
    params: {
        title: '',
        formSaveUrl: '',
        success: function() { },
        cancel: function() { },
        cmp_id: '',
        popOptions: '',
        needLoadData: false
    }
};
Form.PropTypes = {
    cmp_data: React.PropTypes.object.isRequired,
    sub_cmps: React.PropTypes.array.isRequired,
    form_errors: React.PropTypes.object.isRequired,
    biz_data: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired,
    editable: React.PropTypes.bool.isRequired,
    params: React.PropTypes.object
};
export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/Form.js